<template>
  <div class="task_center">
    <div class="owner_title">任务中心</div>
    <!-- 筛选 -->
    <div class="task_head_btn_box">
      <div class="task_head_btn">
        <div
          :class="is_active_btn === 1 ? 'active_btn' : 'book_btn'"
          @click="handleTask(1)"
        >
          <i class="info_icon iconfont icon-kehu"></i>
          我的任务
        </div>
        <div
          :class="is_active_btn === 2 ? 'active_btn' : 'book_btn'"
          @click="handleTask(2)"
        >
          <i class="info_icon iconfont icon-shuliangtongji"></i>
          全部任务
        </div>
      </div>
      <div class="task_filtrate" @click="show_filter_form()">
        <i class="iconfont icon-shaixuan1"></i>
        <span>筛选</span>
      </div>
    </div>

    <!-- 筛选表单 -->
    <div class="task_filter_form" v-show="isFilterForm">
      <el-form
        ref="filter_form"
        :model="filter_form"
        :inline="true"
        class="demo-form-inline"
        label-width="100px"
      >
        <el-form-item label="金主编辑">
          <el-input v-model="filter_form.operator_nickname"></el-input>
        </el-form-item>
        <el-form-item label="任务要求">
          <el-input v-model="filter_form.ask"></el-input>
        </el-form-item>
        <el-form-item label="创建时间">
          <el-date-picker
            v-model="filter_form.createtime"
            value-format="yyyy-MM-dd"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <div class="filter_btn">
            <el-button type="primary" icon="el-icon-search" @click="goSearch"
              >搜索</el-button
            >
          </div></el-form-item
        >
      </el-form>
    </div>

    <div class="task_box">
      <!-- 表格数据--pc端 -->
      <el-table
        v-show="equipmentType == 0 ? true : false"
        class="taskList"
        height="550"
        :data="dataShow"
        border
      >
        <el-table-column type="index" label="序号" align="center" width="50">
        </el-table-column>
        <el-table-column
          property="operator_nickname"
          label="金主编辑"
          align="center"
          sortable
          width="200"
        >
        </el-table-column>
        <el-table-column
          property="name"
          label="书名"
          align="center"
          sortable
          width="250"
        >
        </el-table-column>
        <el-table-column
          property="ask"
          label="任务要求"
          align="center"
          sortable
          :width="is_active_btn == 2 ? 410 : 210"
        >
        </el-table-column>

        <el-table-column
          property="writer_cost"
          label="写手价格"
          sortable
          align="center"
          width="130"
        >
        </el-table-column>
        <el-table-column
          property="actual_cost"
          label="金主价格"
          align="center"
          sortable
          width="130"
        >
        </el-table-column>
        <el-table-column
          property="receive_num"
          label="已接人数"
          align="center"
          sortable
          width="130"
        >
        </el-table-column>
        <el-table-column
          property="trial_draft_num"
          label="已给试稿数"
          align="center"
          width="140"
          sortable
        >
        </el-table-column>
        <el-table-column
          property="createtime"
          label="创建时间"
          align="center"
          width="180"
          sortable
        >
        </el-table-column>
        <el-table-column
          v-if="isMy === 1 ? true : false"
          fixed="right"
          :label="isMy == 1 ? '操作' : ''"
          align="center"
          :width="isMy === 1 ? 400 : 0"
        >
          <template slot-scope="scope">
            <!-- //is_display是否显示按钮 0-不显示 1-显示 -->
            <div
              class="task_btn_box"
              v-show="scope.row.is_display == 0 ? false : true"
            >
              <div @click="showMenuscript(scope.row)" class="task_btn">
                <i class="iconfont icon-xiazai task_icon"></i>
                查看投稿
              </div>
              <div
                @click="accessRecord(scope.row)"
                size="small"
                type="text"
                class="task_btn"
                round
              >
                <i class="iconfont icon-jilu task_icon"></i>
                访问记录
              </div>
              <div
                @click="choiceWriter(scope.row)"
                size="small"
                type="text"
                class="task_btn"
                round
              >
                <i class="iconfont icon-tongguo task_icon"></i>
                选择写手
              </div>
              <div
                @click="editTask(scope.row)"
                size="small"
                type="text"
                class="task_btn"
                round
              >
                <i class="el-icon-edit-outline"></i>
                修改
              </div>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <!-- 表格数据--移动端   -->
      <el-table
        v-show="equipmentType == 1 ? true : false"
        class="taskList"
        v-horizontal-scroll="'always'"
        :data="taskList"
        width="100%"
        border
      >
        <el-table-column type="index" label="序号" align="center" width="50">
        </el-table-column>
        <el-table-column
          property="operator_nickname"
          label="金主编辑"
          width="101"
          align="center"
          sortable
        >
        </el-table-column>
        <el-table-column property="name" label="书名" align="center" sortable>
        </el-table-column>
        <el-table-column
          property="ask"
          label="任务要求"
          align="center"
          width="110"
          sortable
        >
        </el-table-column>

        <el-table-column property="writer_cost" label="写手价格" align="center">
        </el-table-column>
        <el-table-column
          property="actual_cost"
          label="金主价格"
          align="center"
          width="110"
          sortable
        >
        </el-table-column>
        <el-table-column
          property="receive_num"
          label="已接人数"
          align="center"
          width="110"
          sortable
        >
        </el-table-column>
        <el-table-column
          property="trial_draft_num"
          label="已给试稿数"
          width="120"
          align="center"
          sortable
        >
        </el-table-column>
        <el-table-column
          property="createtime"
          label="创建时间"
          width="110"
          align="center"
          sortable
        >
        </el-table-column>
        <el-table-column
          v-if="isMy === 1 ? true : false"
          :label="isMy == 1 ? '操作' : ''"
          align="center"
          width="400"
        >
          <template slot-scope="scope">
            <!-- //is_display是否显示按钮 0-不显示 1-显示 -->
            <div
              class="task_btn_box"
              v-show="scope.row.is_display == 0 ? false : true"
            >
              <div @click="showMenuscript(scope.row)" class="task_btn">
                <i class="iconfont icon-xiazai task_icon"></i>
                查看投稿
              </div>
              <div
                @click="accessRecord(scope.row)"
                size="small"
                type="text"
                class="task_btn"
                round
              >
                <i class="iconfont icon-jilu task_icon"></i>
                访问记录
              </div>
              <div
                @click="choiceWriter(scope.row)"
                size="small"
                type="text"
                class="task_btn"
                round
              >
                <i class="iconfont icon-tongguo task_icon"></i>
                选择写手
              </div>
              <div
                @click="editTask(scope.row)"
                size="small"
                type="text"
                class="task_btn"
                round
              >
                <i class="el-icon-edit-outline"></i>
                修改
              </div>
            </div>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <el-pagination
        v-show="equipmentType == 0 ? true : false"
        class="pagination_box"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 50, 100, 'all']"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </div>

    <!-- 选择写手弹窗 -->
    <el-dialog
      title="选择已接人"
      :visible.sync="writerDialogVisible"
      :width="equipmentType == 1 ? '90%' : '30%'"
      center
    >
      <el-form :model="writerForm" ref="writerForm" class="writerDialog">
        <el-form-item label="选择已接人:" prop="writeradmin_id">
          <div id="mobile_select">
            <el-select
              v-model="writerForm.writeradmin_id"
              :popper-append-to-body="false"
              placeholder="请选择"
            >
              <el-option
                v-for="item in recipientList"
                :key="item.id"
                :label="item.nickname"
                :value="item.id"
              ></el-option>
            </el-select>
          </div>
        </el-form-item>
        <el-form-item label="确认书名:" prop="name">
          <el-input v-model="writerForm.name" style="width:280px"></el-input>
        </el-form-item>
        <el-form-item label="选择日周结:" prop="settlement_type">
          <el-radio-group
            v-model="writerForm.settlement_type"
            @change="changeLabel"
          >
            <el-radio :label="1">日结</el-radio>
            <el-radio :label="2">周结</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button
          class="dialog_btn"
          round
          type="primary"
          @click="submitCooperation"
          >确认添加</el-button
        >
        <el-button class="dialog_btn" @click="writerDialogVisible = false" round
          >取 消</el-button
        >
      </span>
    </el-dialog>

    <!-- 访问记录弹窗 -->
    <el-dialog
      title="访问记录"
      :visible.sync="recordDialogVisible"
      @close="cancelDialog"
      :width="equipmentType == 1 ? '90%' : '40%'"
    >
      <el-table :data="accessDataShow" border>
        <el-table-column type="index" label="序号" align="center" width="50">
        </el-table-column>
        <el-table-column
          property="nickname"
          sortable
          align="center"
          label="提取人员"
        ></el-table-column>
        <el-table-column
          property="num"
          sortable
          align="center"
          label="提取次数"
        ></el-table-column>
        <el-table-column
          property="createtime"
          sortable
          align="center"
          label="提取时间"
        ></el-table-column>
      </el-table>
      <el-pagination
        v-show="equipmentType == 0 ? true : false"
        @size-change="accessHandleSizeChange"
        @current-change="accessHandleCurrentChange"
        :current-page="accessCurrentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="accessPageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="accessTotal"
      >
      </el-pagination>
      <el-pagination
        v-show="equipmentType == 1 ? true : false"
        @size-change="accessHandleSizeChange"
        @current-change="accessHandleCurrentChange"
        :current-page="accessCurrentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="accessPageSize"
        layout="prev, pager, next, jumper"
        :total="accessTotal"
      >
      </el-pagination>
    </el-dialog>

    <!-- 查看投稿弹窗 -->
    <el-dialog
      title="投稿"
      :visible.sync="menuscriptDialogVisible"
      @close="cancelDialog"
      :width="equipmentType == 1 ? '90%' : '50%'"
    >
      <el-table :data="menuscriptDataShow" border>
        <el-table-column type="index" label="序号" align="center" width="50">
        </el-table-column>
        <el-table-column
          align="center"
          property="nickname"
          sortable
          label="已接投稿人"
        ></el-table-column>
        <el-table-column
          align="center"
          property="filename"
          sortable
          label="试稿名称"
        ></el-table-column>
        <el-table-column
          align="center"
          property="createtime"
          sortable
          label="投稿时间"
        ></el-table-column>
        <el-table-column align="center" label="下载稿件" width="200">
          <template slot-scope="scope">
            <div class="task_dialog_box">
              <div @click="downloadFileDialog(scope.row)" class="task_btn">
                <i class="info_icon iconfont icon-xiazai"></i>
                下载文件
              </div>
              <div @click="handleReject(scope.row)" class="task_btn">
                <i class="info_icon iconfont icon-jujue"></i>
                驳回
              </div>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="control_box">
        <el-pagination
          @size-change="menuscriptHandleSizeChange"
          @current-change="menuscriptHandleCurrentChange"
          :current-page="menuscriptCurrentPage"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="menuscriptPageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="menuscriptTotal"
        >
        </el-pagination>
        <el-button
          type="primary"
          class="download_btn"
          @click="downLoadFile"
          round
        >
          <i class="iconfont icon-xiazai task_icon"></i>
          下载全部稿件
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import axios from "axios";
import {
  task_list,
  access_records,
  recipient_list,
  confirm_cooperation,
  submission_download,
  submission_download_list,
  submission_reject
} from "@/utils/owner";
let previousRouterName = "";
let filter_obj = "";
let cancel_tag = "";
export default {
  data() {
    return {
      baseUrl: this.$global.commonUrl, //路径
      taskList: [], //任务中心列表
      ownerId: "", //金主部门所属id
      accessList: [], //访问记录列表
      menuscriptList: [], //查看投稿列表
      menuscriptIds: [], //查看投稿列表的所有id
      recipientList: [], //已接人列表
      isFilterForm: true, //筛选的展开与收缩
      recordDialogVisible: false, //访问记录弹窗
      menuscriptDialogVisible: false, //查看投稿弹窗
      writerDialogVisible: false, //选择写手弹窗
      writerForm: {
        departmentuser_id: "", //所属金主部id
        connectionessay_id: "", //文章id
        writeradmin_id: "", //负责写手部员工
        name: "", //书名
        settlement_type: "" //日周结 1=日结,2=周结
      },
      // ---列表
      dataShow: [], // 当前页要显示的数据,//显示的金主列表数据
      totalPageData: [], // 分页数据(全部数据已经分好页)
      pageNum: 1, // 共几页
      pageSize: 100, // 每页显示数量
      currentPage: 1, // 当前显示页码
      total: 0, // 总共多少条数据

      // ---访问记录列表

      accessDataShow: [], // 当前页要显示的数据,//显示的金主列表数据
      accessTotalPageData: [], // 分页数据(全部数据已经分好页)
      accessPageNum: 1, // 共几页
      accessPageSize: 10, // 每页显示数量
      accessCurrentPage: 1, // 当前显示页码
      accessTotal: 0, // 总共多少条数据
      // ---查看投稿
      menuscriptDataShow: [], // 当前页要显示的数据,//显示的金主列表数据
      menuscriptTotalPageData: [], // 分页数据(全部数据已经分好页)
      menuscriptPageNum: 1, // 共几页
      menuscriptPageSize: 10, // 每页显示数量
      menuscriptCurrentPage: 1, // 当前显示页码
      menuscriptTotal: 0, // 总共多少条数据

      // dataShowDialog: [], // 访问记录

      // menuscriptDataDialog: [], //投稿弹窗列表
      uploadAllId: "", //下载全部的id
      filter_form: {
        operator_nickname: "", //金主编辑
        ask: "", //任务要求
        createtime: "" //创建时间
      },
      bookName: "", //书名
      menuscriptDialogData: {}, //弹窗刷新列表id
      isMy: 1, //我的任务，全部任务
      is_active_btn: 1, //选中我的任务
      select_time_data: "",
      time_filter: "", //时间筛选
      equipmentType: 0 //判断移动端还是pc端  0：pc  1：移动
    };
  },
  beforeRouteEnter(to, from, next) {
    previousRouterName = from.path;
    cancel_tag = from.params.edit_id;
    if (from.path === "/taskEdit") {
      if (from.params.edit_id == 1) {
        filter_obj = JSON.stringify(from.params.filter);
      } else {
        filter_obj = JSON.stringify(from.params.filter);
      }
      // var createTimeData =
      //   from.params.filter.createtime[0] +
      //   " - " +
      //   from.params.filter.createtime[1];
      // from.params.filter.createtime = createTimeData;

      console.log("跳转参数", filter_obj);
    }
    next();
  },
  created() {
    this.ownerId = JSON.parse(localStorage.getItem("userInfo")).id;
    if (this.isMobile()) {
      this.equipmentType = 1;
    } else {
      this.equipmentType = 0;
    }
    if (previousRouterName === "/taskEdit") {
      var that = this;
      var obj_data = JSON.parse(filter_obj);
      let obj;
      if (cancel_tag == 1) {
        obj = {
          departmentuser_id: this.ownerId,
          ...obj_data
        };
      } else {
        if (obj_data.createtime == "") {
          obj = {
            departmentuser_id: this.ownerId,
            ...obj_data
          };
        } else {
          var createTimeData =
            obj_data.createtime[0] + " - " + obj_data.createtime[1];
          this.filter_form = obj_data;
          obj = {
            departmentuser_id: this.ownerId,
            ...obj_data,
            createtime: createTimeData
          };
        }
      }

      task_list(obj).then(res => {
        if (res.data.code == 1) {
          this.total = res.data.data.length;
          that.taskList = res.data.data;
          that.calcPageData();
        } else {
          this.$message.error(res.data.msg);
        }
      });
    } else {
      this.getTaskList(); //任务中心列表
    }
  },
  methods: {
    // 获取任务中心列表
    getTaskList() {
      var that = this;
      let obj = {
        departmentuser_id: that.ownerId,
        page: 1,
        page_index: 10
      };
      task_list(obj).then(res => {
        if (res.data.code == 1) {
          that.total = res.data.data.length;
          that.taskList = res.data.data;
          that.calcPageData();
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },

    // 修改任务中心信息
    editTask(val) {
      var that = this;
      let data = encodeURIComponent(JSON.stringify(val));
      let filter = JSON.stringify(this.filter_form);
      that.$router.push("/taskEdit?data=" + data + "&filter=" + filter);
    },
    // 我的任务
    handleTask(val) {
      var that = this;
      if (val == 1) {
        that.is_active_btn = 1;
      } else {
        that.is_active_btn = 2;
      }

      that.isMy = val;
      that.taskList = [];
      let obj = {
        departmentuser_id: that.ownerId,
        is_my: val
      };
      task_list(obj).then(res => {
        console.log(res);
        if (res.data.code == 1) {
          that.total = res.data.data.length;
          that.taskList = res.data.data;
          that.calcPageData();
        } else {
          that.taskList = [];
          this.$message.error(res.data.msg);
        }
      });
    },
    // 判断是移动端还是PC端
    isMobile() {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      return flag;
    },
    // 筛选
    goSearch(val) {
      var that = this;
      var date1, date2;
      that.select_time_data = that.filter_form.createtime;
      date1 = that.select_time_data[0];
      date2 = that.select_time_data[1];

      if (val == 0) {
        var time1, time2;
        time1 = that.select_time_data[0];
        time2 = that.select_time_data[1];
        that.time_filter = time1 + " - " + time2;
        that.filter_form.createtime = that.time_filter;
        console.log("刷新", that.select_time_data);
      } else {
        console.log("第一次进入页面");
        if (date1 == undefined && date2 == undefined) {
          that.time_filter = "";
        } else {
          that.time_filter = date1 + " - " + date2;
        }
        console.log("that.time_filter", that.time_filter);
        that.filter_form.createtime = that.time_filter;
      }

      let obj = {
        departmentuser_id: that.ownerId,
        page: 1,
        page_index: 10,
        is_my: that.isMy,
        ...that.filter_form
      };
      task_list(obj).then(res => {
        if (res.data.code == 1) {
          that.total = res.data.data.length;
          that.taskList = res.data.data;
          that.calcPageData();
          that.filter_form.createtime = that.select_time_data;
        } else {
          that.taskList = [];
          this.$message.error(res.data.msg);
        }
      });
    },
    // 访问记录列表
    accessRecord(val) {
      var that = this;
      that.recordDialogVisible = true;
      var obj = {
        departmentuser_id: that.ownerId,
        connectionessay_id: val.id,
        page: 1,
        page_index: 10
      };
      access_records(obj).then(res => {
        if (res.data.code == 1) {
          that.accessTotal = res.data.data.length;
          that.accessList = res.data.data;
          that.accessCalcPageData();
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    // 获取选择写手列表
    getRecipientList(id) {
      var that = this;
      var obj = {
        departmentuser_id: that.ownerId,
        connectionessay_id: id
      };
      recipient_list(obj).then(res => {
        if (res.data.code == 1) {
          that.recipientList = res.data.data;
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    // 查看投稿 -- 驳回
    handleReject(val) {
      var that = this;
      console.log(val);
      var obj = {
        departmentuser_id: that.ownerId,
        articleprocess_id: val.id
      };
      submission_reject(obj).then(res => {
        if (res.data.code == 1) {
          this.$message.success(res.data.msg);
          var obj = {
            departmentuser_id: that.ownerId,
            connectionessay_id: that.uploadAllId
          };
          submission_download_list(obj).then(res => {
            if (res.data.code == 1) {
              that.menuscriptTotal = res.data.data.length;
              that.menuscriptList = res.data.data;
              that.menuscriptCalcPageData();
            } else {
              this.$message.error(res.data.msg);
            }
          });
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    // 查看投稿
    showMenuscript(val) {
      var that = this;
      that.menuscriptDialogData = val;
      that.uploadAllId = val.id;
      that.menuscriptDialogVisible = true;

      var obj = {
        departmentuser_id: that.ownerId,
        connectionessay_id: val.id
      };
      submission_download_list(obj).then(res => {
        if (res.data.code == 1) {
          that.menuscriptTotal = res.data.data.length;
          that.menuscriptList = res.data.data;
          // that.goSearch();
          that.menuscriptCalcPageData();
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    // 投稿弹窗的下载
    downloadFileDialog(val) {
      var that = this;
      var file = val.appendix_files;
      var file_name = val.filename;
      var xurl = val.xurl;
      console.log("投稿弹窗的下载", xurl);

      if (file == " ") {
        this.$message.error("暂无可下载文件");
      } else {
        if (that.equipmentType == 0) {
          // pc端
          var url = that.baseUrl + file;
          var link = document.createElement("a");
          link.style.display = "none";
          link.href = url;
          link.setAttribute("download", file_name);
          document.body.appendChild(link);
          link.click();
        } else {
          // 手机端
          let link = document.createElement("a");
          link.style.display = "none";
          link.href = that.baseUrl + xurl;
          link.setAttribute("download", file_name);
          document.body.appendChild(link);
          console.log("移动端", link);
          link.click();
          URL.revokeObjectURL(link.href); // 释放URL 对象
          document.body.removeChild(link);
        }
      }
    },
    // 选择写手弹窗
    choiceWriter(row) {
      var that = this;
      that.writerDialogVisible = true;
      that.writerForm = { ...row };
      that.writerForm.checkWriter = that.recipientList;
      that.getRecipientList(that.writerForm.id); //选择写手列表
    },
    //选择周日结
    changeLabel(val) {
      this.writerForm.settlement_type = val;
    },
    // 确认合作
    submitCooperation() {
      var that = this;
      var obj = {
        departmentuser_id: that.ownerId,
        connectionessay_id: that.writerForm.id, //文章id
        writeradmin_id: that.writerForm.writeradmin_id, //负责写手部员工
        name: that.writerForm.name,
        settlement_type: that.writerForm.settlement_type
      };
      confirm_cooperation(obj).then(res => {
        if (res.data.code == 1) {
          that.$message.success(res.data.msg);
          that.writerDialogVisible = false;
          that.goSearch();
          // that.getTaskList();
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    //查看投稿--下载
    downLoadFile() {
      var that = this;
      let obj = {
        departmentuser_id: that.ownerId,
        connectionessay_id: that.uploadAllId
      };
      submission_download(obj).then(res => {
        if (res.data.code == 1) {
          console.log(res);
          let file_name = res.data.data.title;
          let fileUrl = res.data.data.url;
          let xurl = res.data.data.xurl;
          console.log("全部", xurl);
          if (that.equipmentType == 0) {
            // pc端
            let url = that.baseUrl + fileUrl;
            let link = document.createElement("a");
            link.style.display = "none";
            link.href = url;
            link.setAttribute("download", file_name);
            document.body.appendChild(link);
            link.click();
          } else {
            // 移动端
            let link = document.createElement("a");
            link.style.display = "none";
            link.href = that.baseUrl + xurl;
            link.setAttribute("download", file_name);
            document.body.appendChild(link);
            console.log("移动端", link);
            link.click();
            URL.revokeObjectURL(link.href); // 释放URL 对象
            document.body.removeChild(link);
          }

          that.$message.success(res.data.msg);
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    // 打开筛选表单
    show_filter_form() {
      var that = this;
      that.isFilterForm = !that.isFilterForm;
    },
    // 关闭弹窗触发
    cancelDialog() {
      this.goSearch();
    },
    //任务中心 -列表
    calcPageData() {
      if (this.taskList.length > 1) {
        this.pageNum = Math.ceil(this.taskList.length / this.pageSize) || 1;
      }
      for (let i = 0; i < this.pageNum; i++) {
        this.totalPageData[i] = this.taskList.slice(
          this.pageSize * i,
          this.pageSize * (i + 1)
        );
      }
      this.dataShow = this.totalPageData[this.currentPage - 1];
    },
    handleSizeChange(val) {
      if (isNaN(val)) {
        this.pageSize = this.total;
      } else {
        this.pageSize = val;
      }
      this.calcPageData();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.dataShow = this.totalPageData[val - 1];
    },
    //任务中心 -查看访问记录
    accessCalcPageData() {
      if (this.accessList.length > 1) {
        this.accessPageNum =
          Math.ceil(this.accessList.length / this.accessPageSize) || 1;
      }
      for (let i = 0; i < this.accessPageNum; i++) {
        this.accessTotalPageData[i] = this.accessList.slice(
          this.accessPageSize * i,
          this.accessPageSize * (i + 1)
        );
      }
      this.accessDataShow = this.accessTotalPageData[
        this.accessCurrentPage - 1
      ];
    },
    accessHandleSizeChange(val) {
      this.accessPageSize = val;
      this.accessCalcPageData();
    },
    accessHandleCurrentChange(val) {
      this.accessCurrentPage = val;
      this.accessDataShow = this.accessTotalPageData[val - 1];
    },
    //任务中心 -查看投稿
    menuscriptCalcPageData() {
      if (this.menuscriptList.length > 1) {
        this.menuscriptPageNum =
          Math.ceil(this.menuscriptList.length / this.menuscriptPageSize) || 1;
      }
      for (let i = 0; i < this.menuscriptPageNum; i++) {
        this.menuscriptTotalPageData[i] = this.menuscriptList.slice(
          this.menuscriptPageSize * i,
          this.menuscriptPageSize * (i + 1)
        );
      }
      this.menuscriptDataShow = this.menuscriptTotalPageData[
        this.menuscriptCurrentPage - 1
      ];
    },
    menuscriptHandleSizeChange(val) {
      this.menuscriptPageSize = val;
      this.accessCalcPageData();
    },
    menuscriptHandleCurrentChange(val) {
      this.menuscriptCurrentPage = val;
      this.menuscriptDataShow = this.menuscriptTotalPageData[val - 1];
      console.log("查看投稿", this.menuscriptDataShow);
    }
  }
};
</script>
<style scoped>
.el-main {
  margin: 0px;
  padding: 0px;
  background: #f5f7fa;
}
.owner_title {
  font-size: 17px;
  font-family: Source Han Sans CN-Regular, Source Han Sans CN;
  font-weight: 400;
  color: #304265;
  background: #ffffff;
  padding: 15px;
  border: 1px solid #e4e9f1;
}
.task_box {
  margin: 0px 15px;
}
.task_btn_box {
  display: flex;
  flex-direction: row;
}
.task_btn i {
  font-size: 12px;
}
.task_btn {
  width: 90px;
  height: 20px;
  line-height: 20px;
  background: #e7f2ff;
  color: #157df8;
  border-radius: 10px;
  margin: 0px 5px;
  font-size: 12px;
}
.task_icon {
  font-size: 12px;
}
.task_filtrate {
  text-align: right;
  padding: 10px 15px 10px 15px;
}
.task_filtrate i {
  font-size: 14px;
}
.task_filtrate span {
  font-size: 14px;
  font-family: Source Han Sans CN-Regular, Source Han Sans CN;
  font-weight: 400;
  color: #8893a7;
}
.task_filter_form {
  background: #ffffff;
  margin: 0px 15px;
  padding-top: 15px;
}
.pagination_box {
  float: right;
  margin-top: 15px;
  margin-right: 15px;
}
.control_box {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  margin-top: 10px;
}
.download_btn {
  color: #fff;
  background: #157df8;
  height: 30px;
  line-height: 0px;
}
.download_btn i {
  font-size: 15px;
}
.task_head_btn_box {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}
.task_dialog_box {
  display: flex;
  flex-direction: row;
}
.task_head_btn {
  display: flex;
  flex-direction: row;
  margin: 15px;
}
.book_btn {
  width: 100px;
  height: 30px;
  line-height: 30px;
  text-align: center;
  background: #e7f2ff;
  border-radius: 4px;
  color: #157df8;
  font-size: 14px;
  margin-right: 10px;
}
.active_btn {
  width: 100px;
  height: 30px;
  line-height: 30px;
  text-align: center;
  background: #157df8;
  border-radius: 4px;
  color: #e7f2ff;
  font-size: 14px;
  margin-right: 10px;
}
.el-select-dropdown {
  background: pink !important;
}
@media screen and (max-width: 750px) and (min-width: 375px) {
  .task_box {
    margin-bottom: 150px;
  }
  .filter_btn {
    margin-left: 30px;
    padding-bottom: 5px;
  }
  /* .task_btn_box {
    display: flex;
    flex-direction: column;
  } */

  .task_btn i {
    font-size: 12px;
  }
  .task_btn {
    width: 90px;
    height: 20px;
    line-height: 20px;
    background: #e7f2ff;
    color: #157df8;
    border-radius: 10px;
    margin-bottom: 5px;
    font-size: 12px;
  }
  .task_head_btn {
    margin: 0px 15px;
  }
  .task_center .el-select-dropdown {
    position: absolute !important;
    top: 30px !important;
    left: 0px !important;
  }
  /* .el-date-editor--daterange.el-input,
  .el-date-editor--daterange.el-input__inner,
  .el-date-editor--timerange.el-input,
  .el-date-editor--timerange.el-input__inner {
    width: 235px !important;
  } */
}
#mobile_select >>> .el-select-dropdown {
  position: absolute !important;
  top: 30px !important;
  left: 0px !important;
}
</style>



// WEBPACK FOOTER //
// src/view/owner/TaskCenter.vue